import type { Meta, StoryFn } from '@storybook/react';

import { Link, MetaList, Status } from '@pega/cosmos-react-core';
import type { MetaListProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/MetaList',
  component: MetaList
} as Meta;

interface MetaListStoryProps {
  wrapItems?: MetaListProps['wrapItems'];
}

export const MetaListDemo: StoryFn<MetaListStoryProps> = (args: MetaListStoryProps) => {
  return (
    <MetaList
      wrapItems={args.wrapItems}
      items={[
        'email@example.com',
        <Status variant='success'>Verified</Status>,
        <>
          Go to{' '}
          <Link href='https://www.pega.com' target='_blank'>
            Pega.com
          </Link>
        </>
      ]}
    />
  );
};

MetaListDemo.args = {
  wrapItems: true
};

MetaListDemo.argTypes = {
  wrapItems: { control: { type: 'boolean' } }
};
